<template>
  <!--时间线-->
  <div class="timeLine" style="overflow: hidden;">
    <div class="ul_box">
      <ul class="my_timeline" ref="mytimeline">
        <li
          class="my_timeline_item_first"
          :key="0"
          :class="{active: timeIndex == 0, success: 0 &lt;timeIndex}"
        >
          <div
            class="my_timeline_item_content"
            :style="{fontSize: timeLine_first.fontsize + 'rem'}"
          >{{timeLine_first.timestamp}}</div>
        </li>
        <li
          class="my_timeline_item_middle"
          v-for="(item,index) in timeLine_middle"
          :key="index"
          :class="{active: (index+1) == timeIndex, success: (index+1) &lt;timeIndex}"
        >
          <div
            class="my_timeline_item_content"
            :style="{fontSize: item.fontsize + 'rem'}"
          >{{item.timestamp}}</div>
        </li>
        <li
          class="my_timeline_item_last"
          :key="5"
          :class="{active: timeIndex == 4, success:4 &lt;timeIndex}"
        >
          <div
            class="my_timeline_item_content"
            :style="{fontSize: timeLine_last.fontsize + 'rem'}"
          >{{timeLine_last.timestamp}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZjTimeLine",
  controller: "UI",
  action: "TimeLine",
  props: {
    timeIndex: { type: Number, default: 0 }
  },
  data() {
    return {
      timeLine_first: {
        timestamp: "事件接报",
        color: "#999",
        fontsize: 1.8,
        size: "23",
        bgcolor: "#e4e7ed",
        icon: "el-iconprev"
      },
      timeLine_middle: [
        {
          timestamp: "事件核实",
          color: "#999",
          fontsize: 1.8,
          size: "23",
          bgcolor: "#e4e7ed"
        },
        {
          timestamp: "事件上报",
          color: "#999",
          fontsize: 1.8,
          size: "23",
          bgcolor: "#e4e7ed"
        },
        {
          timestamp: "应急指挥",
          color: "#999",
          fontsize: 1.8,
          size: "23",
          bgcolor: "#e4e7ed"
        }
      ],
      timeLine_last: {
        timestamp: "事件总结",
        color: "#999",
        fontsize: 1.8,
        size: "23",
        bgcolor: "#e4e7ed"
      }
    };
  },
  methods: {
    changeActive(index) {
      this.timeIndex = index;
    }
  }
};
</script>

<style scoped>
.ul_box {
  width: 100%;
  /*height: 12rem;*/
  display: inline-block;
  /*margin-top: 4rem;*/
  overflow: hidden;
  text-align: center;
}

.my_timeline{
  padding: 0;
}

.my_timeline_item_first {
  background: url(../../../theme-default/src/images/first_w.png) no-repeat
    center center;
    background-size: 100% 100%;
  display: inline-block;
  width: 24rem;
  height: 7rem;
}
.my_timeline_item_first.active {
  background: url(../../../theme-default/src/images/first_p.png) no-repeat
    center center;
    background-size: 100% 100%;
}
.my_timeline_item_first.success {
  background: url(../../../theme-default/src/images/first_f.png) no-repeat
    center center;
    background-size: 100% 100%;
}

.my_timeline_item_middle {
  background: url(../../../theme-default/src/images/middle_w.png) no-repeat
    center center;
  display: inline-block;
  background-size: 100% 100%;
  width: 24rem;
  height: 7rem;
}
.my_timeline_item_middle.active {
  background: url(../../../theme-default/src/images/middle_p.png) no-repeat
    center center;
    background-size: 100% 100%;
}
.my_timeline_item_middle.success {
  background: url(../../../theme-default/src/images/middle_f.png) no-repeat
    center center;
    background-size: 100% 100%;
}

.my_timeline_item_last {
  background: url(../../../theme-default/src/images/last_w.png) no-repeat center
    center;
  display: inline-block;
  background-size: 100% 100%;
  width: 24rem;
  height: 7rem;
}
.my_timeline_item_last.active {
  background: url(../../../theme-default/src/images/last_p.png) no-repeat center
    center;
    background-size: 100% 100%;
}
.my_timeline_item_last.success {
  background: url(../../../theme-default/src/images/last_f.png) no-repeat center
    center;
    background-size: 100% 100%;
}

.my_timeline_item_content {
  text-align: center;
  margin-top:3.5rem;
  color: #fff;
}
</style>